/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const intakeFormResponses = sqliteTable('intake_form_responses', {
  id: text('id').primaryKey().notNull(),
  patient_intake_form_id: text('patient_intake_form_id'),
  answers: text('answers'),
});
